module.exports = __webpack_public_path__ + "static/media/virgen-coromoto-coronacion-small.46ef8fbb.jpg";